module.exports = __webpack_public_path__ + "img/step_img2.caeb18dc.png";